var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 123,
    viewBox: "0 0 125 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0105 87.8329L84.8003 88.8106L85.0105 87.8329C83.7353 87.5588 82.5432 88.5589 82.5915 89.8623L83.7805 121.94L64.0689 96.6091C63.2682 95.5801 61.7128 95.5801 60.9121 96.6091L41.2004 121.94L42.3895 89.8625C42.4378 88.559 41.2455 87.5588 39.9703 87.8331L8.60644 94.5793L30.125 70.7739C30.9995 69.8065 30.7291 68.2743 29.5762 67.6647L1.20813 52.6648L32.9926 48.2619C34.2841 48.083 35.0619 46.7359 34.571 45.5279L22.497 15.8127L49.6775 32.8726C50.7821 33.5659 52.244 33.0336 52.6442 31.7924L62.4913 1.25582L72.3556 31.7937C72.7563 33.0343 74.2178 33.566 75.322 32.873L102.501 15.814L90.411 45.527C89.9194 46.7352 90.6972 48.083 91.9892 48.2619L123.79 52.6648L95.4059 67.6645C94.2524 68.2741 93.9819 69.807 94.8572 70.7745L116.392 94.5793L85.0105 87.8329Z",
    stroke: "#FF9C40",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/shape5.17ea39810dae4fc599c88833c075bec2.svg";
export { ForwardRef as ReactComponent };